import React from 'react';

class LoadingSpinner extends React.Component {
  render() {
    const { className } = this.props

    return (
		  <button
		    className={className}
		    disabled="disabled"
		  >
		    <i className="loader" />
		  </button>
    );
  }
}

export default LoadingSpinner;